<div class="container">
  <div id="app-container" class="app-container">
    <router-outlet *ngIf="reloadRouterOutlet"></router-outlet>
  </div>
  <div class="nav-menu">
    <navmenu></navmenu>
  </div>
</div>
